<template>
  <div id="ProjectEditSummary">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">项目概述</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">项目编号</div>
          <el-input v-model="project.projectCode" class="eb-input panel-body-row-right" placeholder="请输入项目编号"></el-input>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">项目名称</div>
          <el-input v-model="project.projectName" class="eb-input panel-body-row-right" placeholder="请输入项目名称"></el-input>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">项目简介</div>
          <div class="panel-body-row-right">
            <el-input v-model="project.projectInfo" class="eb-textarea" type="textarea" placeholder="请输入项目简介">
            </el-input>
          </div>
        </div>
      </div>
    </eb-panel>

  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'ProjectEditSummary',
  props: ['project'],
  components: {
    ebPanel,
    ebPanelHeader
  }
};
</script>
<style scoped lang="less">
.eb-textarea {
  height: 171px;
}
.projectInfo {
  align-items:flex-start!important;
  padding-top:8px;
}
</style>
